var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PinkPuk'),_c('SimCardBlock'),_c('SimCardUnBlock'),_c('SimCardActivateGPRS'),_c('SimCardDeActivateGPRS'),_c('CommingSoonPop'),_c('SimCardSWAP'),_c('SimCardMe2u'),_c('MyNumbers')],1)}
var staticRenderFns = []

export { render, staticRenderFns }